import React from "react";
import CloseModalBtn from "../../shared/CloseModalBtn";
import useAddOrEditUser from "../../TableauDebord/Admin/ListeUsers/hooks/useAddOrEditUser";
import { IUser, UserType } from "../../../utils/api/user/user.type";
import { BtnSubmit } from "../../common/Button";
import { AdminInput, FormError, RequiredStar } from "../../common/Input";
import { PreviewImage } from "../../common/PreviewImage";
import PhoneInput from "react-phone-input-2";
import GoogleInput from "../../common/GoogleInput";
import { CountrySelector } from "volkeno-react-country-state-city";
import "volkeno-react-country-state-city/dist/index.css";

const modalId = "AddPharmacieModal";
const AddPharmacieModal = ({
  item,
  resetItem,
}: {
  resetItem: () => void;
  item?: IUser;
}) => {
  const {
    register,
    onSubmit,
    errors,
    isLoading,
    phone,
    onChangePhone,
    picture,
    handleChangePicture,
    setPhone,
    handleChangeAdress,
    country,
    handleCountrySelect,
    handleReset,
  } = useAddOrEditUser(resetItem, UserType.pharmacien, modalId, item);
  const reset = () => {
    resetItem();
    setPhone("");
  };
  return (
		<div className="modal-dialog modal-lg">
			<div className="modal-content">
				<div className="modal-header py-2 flex-m">
					<h5 className="admin-modal-title text-start">
						{item ? "Modifier la" : "Ajouter une"}{" "}
						pharmacie
					</h5>
					<CloseModalBtn
						onClick={() => {
							handleReset();
						}}
					/>
				</div>
				<div className="modal-body">
					<div className="container-form">
						<form onSubmit={onSubmit}>
							<div className="row">
								<div className="col-md-6">
									<AdminInput
										label="Nom du pharmacien"
										id="nom"
										type="text"
										placeholder="Nom du pharmacien"
										{...register("nom")}
										error={errors?.nom}
										required
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Prénom du pharmacien"
										id="prenom"
										type="text"
										placeholder="Prénom du pharmacien"
										{...register(
											"prenom"
										)}
										error={
											errors?.prenom
										}
										required
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Nom de la pharmacie"
										id="nom_pharmacie"
										type="text"
										required
										placeholder="Nom de la pharmacie"
										{...register(
											"nom_pharmacie"
										)}
										error={
											errors?.nom_pharmacie
										}
									/>
								</div>
								<div className="col-md-6">
									<label
										htmlFor="adress"
										className="form-label form-label-modal-custom"
									>
										Adresse de la
										pharmacie
										<RequiredStar />
									</label>
									<GoogleInput
										value={
											item?.adresse ??
											""
										}
										onChange={
											handleChangeAdress
										}
										className="form-control form-control-modal-custom"
									/>
									<FormError
										error={
											errors?.adresse
										}
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Adresse mail"
										required
										id="email"
										type="text"
										placeholder="Adresse mail"
										{...register(
											"email"
										)}
										error={
											errors?.email
										}
										inputMode="text"
									/>
								</div>

								<div className="col-md-6">
									<div className="mb-3">
										<label
											htmlFor="telephone"
											className="form-label form-label-modal-custom"
										>
											Numéro de
											téléphone
											<RequiredStar />
										</label>
										<PhoneInput
											defaultMask={
												".. ... .. .."
											}
											containerClass="form-control auth-form-control mb-3 p-0"
											inputClass="form-control form-control-modal-custom py-4"
											country={"sn"}
											placeholder=""
											inputProps={{
												name: "telephone",
												required: true,
											}}
											prefix="+"
											value={phone}
											onChange={(
												phone,
												country
											) =>
												onChangePhone(
													phone,
													country
												)
											}
											inputStyle={{
												width: "100%",
											}}
										/>
										<FormError
											error={
												errors
													?.telephone
													?.message
											}
										/>
									</div>
								</div>
								<div className="col-md-6">
									<label
										htmlFor="pays"
										className="form-label form-label-modal-custom"
									>
										Pays
									</label>
									<CountrySelector
										onChange={
											handleCountrySelect
										}
										name="pays"
										placeholder="Selectionner un pays"
										value={country}
										containerClass=" select-container"
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Ville"
										id="ville"
										type="text"
										placeholder="Ville"
										{...register(
											"ville"
										)}
										error={
											errors?.ville
										}
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Rue"
										id="rue"
										type="text"
										placeholder="Rue"
										{...register("rue")}
										error={errors?.rue}
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Code postal"
										id="code_postal"
										type="text"
										minLength={5}
										maxLength={5}
										min={0}
										placeholder="Code postal"
										{...register(
											"code_postal"
										)}
										error={
											errors?.code_postal
										}
										inputMode="text"
									/>
								</div>
								<div className="col-md-6">
									<AdminInput
										label="Photo de profil"
										id="avatar"
										type="file"
										accept="image/*"
										onChange={
											handleChangePicture
										}
									/>
									<PreviewImage
										image={picture}
									/>
								</div>
							</div>
							<div className="container-btn-modal flex-r gap-3 mt-4">
								<button
									type="button"
									className="btn btn-cancelled"
									data-bs-dismiss="modal"
									// onClick={reset}
									onClick={() => {
										reset();
										handleReset();
									}}
								>
									Annuler
								</button>
								<BtnSubmit
									isLoading={isLoading}
									label={
										item
											? "Modifier"
											: "Ajouter"
									}
									style={{
										width: "inherit",
									}}
								/>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
  );
};

export default AddPharmacieModal;
